export default __webpack_public_path__ + "static/media/qrcode.fe32aa29.gif";